/**
 * Analytics capability keys — the EXACT server capability strings (server/src/modules/analytics/
 * {analytics.module.js,routes.js}). The two real routes (GET /analytics/tableau, POST
 * /analytics/snapshot) are both gated on `analytics.tableau.view`; the other four are declared on the
 * module manifest for the cross-lab / per-band reads that follow the same shape (AN-1/AN-4). useCan /
 * nav gating / ProtectedRoute all key off these. The server re-checks every request — these only
 * hide/disable UI (never the trust boundary).
 */
export const ANALYTICS_CAPS = {
  /** The dashboard read + the deterministic snapshot trigger (both routes). */
  tableauView: "analytics.tableau.view",
  /** Declared band reads (manifest) — used to gate the per-band detail tiles. */
  tatRead: "analytics.tat.read",
  referralRead: "analytics.referral.read",
  qcRead: "analytics.qc.read",
  financeRead: "analytics.finance.read",
} as const;

export type AnalyticsCapability = (typeof ANALYTICS_CAPS)[keyof typeof ANALYTICS_CAPS];

/** The module gate — reaching any analytics surface requires the dashboard read. */
export const MODULE_CAPS: ReadonlyArray<string> = [ANALYTICS_CAPS.tableauView];
